<template>
  <section>
    <div class="form-tip">
      <p>1. 结算款支付必须上传带有公章的 结算审核意见表 作为附件。</p>
    </div>
    <div class="tip" style="margin:0 0 0 20px">* 项目支付基本资料</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目名称">
          <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="合同编号">
          <el-input size="small" v-model="form.htbh" placeholder="请输入合同编号"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="合同造价">
          <el-input size="small" v-model="form.htzj" placeholder="请输入合同造价"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="补充造价">
          <el-input size="small" v-model="form.bczj" placeholder="请输入补充造价"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="支付期数">
          <el-input size="small" v-model="form.zfqs" placeholder="请输入支付期数"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="结算审核造价">
          <el-input size="small" v-model="form.jsshzj" placeholder="请输入结算审核造价"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="本期前累计支付工程款" label-width="170px">
          <el-input size="small" v-model="form.ljzfgck" placeholder="本期前累计支付工程款"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="本期支付（支付至审核造价 %）" label-width="220px">
          <el-row :gutter="5">
            <el-col :span="11">
              <el-input size="small" v-model="form.bqzf" placeholder="本期支付"></el-input>
            </el-col>
            <el-col :span="12">
              <el-input size="small" v-model="form.zfzshzj" placeholder="支付 %"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-form-item label="支付简注">
        <el-input type="textarea" placeholder="简注" :autosize="{ minRows: 3, maxRows: 6}" size="small" v-model="form.remark"></el-input>
      </el-form-item>
    </div>
  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData', 'teamArr', 'projectArr'],
    data() {
      return {
        form: {},
        moneyApprovalList: [],
      }
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      },
      form: {
        handler(newName, oldName) {
          if (this.form.bqzf && this.form.jsshzj) {
            this.form.zfzshzj = 100 * Math.floor(this.form.bqzf / this.form.jsshzj * 10000) / 10000 + "%"
          }
        },
        deep: true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createSettlementPayApproval.vue